import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const buyers = [{
  name: 'María',
  country: 'México'
}, {
  name: 'Laura',
  country: 'Colombia'
}, {
  name: 'Sofía',
  country: 'España'
}, {
  name: 'Camila',
  country: 'Argentina'
}, {
  name: 'Valentina',
  country: 'Chile'
}, {
  name: 'Ana',
  country: 'Perú'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Show for 5 seconds
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 10000);
    // Recurring interval
    const interval = setInterval(() => {
      showPopup();
    }, 25000); // Every 25 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-145">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      duration: 0.4,
      type: 'spring'
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 bg-white rounded-lg shadow-2xl border border-brand-cream p-4 flex items-center gap-4 max-w-sm" data-id="element-146">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-147">
            <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-148" />
          </div>
          <div data-id="element-149">
            <p className="text-sm text-gray-800 font-medium leading-tight" data-id="element-150">
              <span className="font-bold text-brand-wine" data-id="element-151">
                {currentBuyer.name}
              </span>{' '}
              de {currentBuyer.country}
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-152">
              Acaba de comprar MERECES MÁS
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}